import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import moment from "moment";
import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function Cms() {
  
  const { showPage, setShowPage } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    getBranch();
  }, []);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    status: Yup.string().required("required"),
  });

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/cms/get-cms-data`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
    setValue(item?.subTitle);
  };

  // const openAddTournament = (value) => {
  //   setRowValue();
  //   console.log("openAddTournament :::", value);
  //   setShowPage(true);
  //   setOpenValue(value);
  // };

  const updateCoinPackage = (values) => {
    const payload = { ...values, id: rowValue._id };
    console.log("payload::: ", payload);
    axios
      .patch(
        `${API_URL}/api/admin/cms/update-cms-status/${rowValue._id}`,
        payload
      )
      .then((res) => {
        console.log("update :::", res.data);

        if (res.data.status) {
          setButtonLoader(false);
          socket.emit("coinPackageUpdate");
          successEdit(res.data.message);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setButtonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/admin/cms/create-cms-data`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.status) {
          setButtonLoader(false);
          socket.emit("coinPackageAdd");
          successAdd(result.data.message);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this CMS record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">{msg || "The CMS record has been successfully removed."}</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios
      .delete(`${API_URL}/api/admin/cms/delete-cms-data/${e._id}`)
      .then((res) => {
        if (res.data.status) {
          successDeleted(res.data.message);
          socket.emit("coinPackageDelete");
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The CMS record has been added successfully."}</p>
      </SweetAlert>
    );
  };

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Updated!</div>
        <p className="premium-alert-text">{msg || "The CMS record has been updated successfully."}</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  title: rowValue ? rowValue?.title : "",
                  subTitle: rowValue ? rowValue?.subTitle : "",
                  status: rowValue ? rowValue?.status : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  console.log("onSubmit---values::: ", values);
                  setButtonLoader(true);
                  // console.log("update formik value :::", values, openValue);
                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);

                    console.log(
                      "updateCoinPackage???????????????//::: ",
                      values
                    );
                    updateCoinPackage(values);
                  }
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <div>
                    <Form>
                      <div className="form-group">
                        <label htmlFor="password">Title</label>
                        <Field
                          type="text"
                          name="title"
                          placeholder="title"
                          className={`mt-2 form-control
                          ${touched.title && errors.title ? "is-invalid" : ""}`}
                        />
                        <ErrorMessage
                          component="div"
                          name="title"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="form-group">
                        <ReactQuill
                          value={values.subTitle}
                          onChange={(content) =>
                            setFieldValue("subTitle", content)
                          }
                          className="custom-quill"
                          theme="snow"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password" className="">
                          Status
                        </label>
                        <Field
                          as="select"
                          name="status"
                          className={`form-control
                          ${
                            touched.status && errors.status ? "is-invalid" : ""
                          }`}
                        >
                          <option value={2}>Select Status</option>
                          <option value={0}>Active</option>
                          <option value={1}>Unactive</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="status"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="d-flex">
                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-primary btn-block mt-4 mr-2"
                          disabled={buttonLoader}
                          // disabled={true}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="d-flex"
                              style={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <b>Submit</b>
                            </div>
                            {buttonLoader && (
                              <div>
                                <div
                                  class="spinner-border ml-2 mt-1"
                                  role="status"
                                  style={{ height: "20px", width: "20px" }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </button>
                        <button
                          style={{ width: "100px" }}
                          onClick={() => setShowPage(false)}
                          type="button"
                          className="btn btn-secondary btn-block mt-4 ms-2"
                        >
                          Close
                        </button>
                      </div>
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card " style={{ overflow: "scroll" }}>
            <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "" }}
            >
              {/* <button
                style={{ width: "118px" }}
                onClick={() => {
                  openAddTournament(1);
                }}
                type="button"
                className="btn btn-primary btn-block "
              >
                <AddIcon />
                Add New
              </button> */}

              {/* <div>
                <input
                  class="input-simple"
                  type="text"
                  placeholder="Search Email..."
                  value={searchSubType}
                  onChange={(e) => setSearchTourName(e.target.value)}
                />
              </div> */}
            </div>

            <div class="card-body">
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Title</th>
                    {/* <th>Sub Title</th> */}
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            .reverse()
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>
                                    {moment(item.createdAt).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>{item.title}</td>
                                  {/* <td> */}
                                  {/* {item.subTitle?.length > 54 ? "..." : ""} */}
                                  {/* <div
                                      className="upifymeBlog"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          item.subTitle?.substring(0, 54) +
                                          (item.subTitle?.length > 54
                                            ? "..."
                                            : ""),
                                      }}
                                    /> */}
                                  {/* </td> */}
                                  <td>
                                    {item.status === 0
                                      ? "Active"
                                      : item.status === 1
                                      ? "Unactive"
                                      : "-"}
                                  </td>
                                  <td className="d-flex justify-content-evenly ">
                                    <EditIcon
                                      className="mr-3 courser"
                                      onClick={() => clickEditButton(item)}
                                    />
                                    {/* <ClearIcon
                                      className="courser text-danger"
                                      onClick={() =>
                                        warningWithConfirmMessage(item)
                                      }
                                    /> */}
                                  </td>
                                </tr>
                              </>
                            ))}
                        </>
                        ) : (
                          <EmptyState colSpan={8} />
                        )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={tableData.length}
            />
          </div>
        </div>
      )}
    </>
  );
}
